import { render, staticRenderFns } from "./TemplateMailForm.vue?vue&type=template&id=713e3e8b&"
import script from "./TemplateMailForm.vue?vue&type=script&lang=js&"
export * from "./TemplateMailForm.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMailForm.vue?vue&type=style&index=0&id=713e3e8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports